import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { colors } from '@datacamp/waffles-tokens';
import * as React from 'react';
import Droppable from './Droppable';
import { jsx as ___EmotionJSX } from "@emotion/react";
const getBiggestItem = items => {
  return items.reduce((currentBiggestItem, currentItem) => {
    if (currentBiggestItem.content.length < currentItem.content.length) {
      return currentItem;
    }
    return currentBiggestItem;
  }, items[0]);
};
const TopAreaDroppable = _ref => {
  let {
    droppableId,
    items = [],
    languageOfTarget,
    maxOffset,
    padding,
    setItemOffset
  } = _ref;
  const [innerDroppableHeight, setInnerDroppableHeight] = React.useState(0);
  const item = innerDroppableHeight ? items[0] : getBiggestItem(items);
  const innerContainerRefCallback = React.useCallback(containerRef => {
    if (!containerRef) {
      return;
    }
    if (item !== null && item !== void 0 && item.htmlContent && containerRef.textContent.trim().length === 0) {
      // the content is html, and doesn't contain text. We can't set the height this way and need it to assume its own height
      setInnerDroppableHeight(-1);
    } else {
      setInnerDroppableHeight(containerRef.offsetHeight);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return ___EmotionJSX(Droppable, {
    droppableId: droppableId,
    extraClass: item ? 'dc-u-w-100pc' : 'dc-u-w-100pc dc-u-h-128',
    innerContainerRefCallback: innerContainerRefCallback,
    items: item ? [item] : [],
    key: droppableId,
    languageOfTarget: languageOfTarget,
    maxOffset: maxOffset,
    overrideDropStyle: _objectSpread({
      border: "1px dashed ".concat(colors.white),
      color: item ? 'inherit' : 'white',
      margin: 0,
      minHeight: undefined,
      overflow: 'hidden'
    }, innerDroppableHeight > 0 ? {
      height: innerDroppableHeight - padding
    } : {
      minHeight: 0
    }),
    setItemOffset: setItemOffset,
    title: ___EmotionJSX("div", null)
  });
};
export default TopAreaDroppable;